import LzYUser from '@lz-modules/built-in/User';

const UserModule = new LzYUser({});

export default UserModule;
